import AutoIntegrationForm from './AutoIntegrationForm';

export default AutoIntegrationForm;
export * from './AutoIntegrationForm';
